import message from '@/utils/message';
import i18n from '@/locales/i18n';
import {
  paginatedFeedFetchPage,
  paginatedFeedLoadMore,
} from '@/domain/market/paginated-feed-core.js';
import { paginatedFeedGetPlatform } from '@/domain/market/paginated-feed-pagination.js';
import { resolveRequestErrorMessage } from '@/utils/request-error.js';
import { scheduleFeedFairOddsRefresh } from '@/stores/feed-fair-odds-refresh.js';

export function notifyFeedFetchError(err, options = {}) {
  const { silent = false, showError = true, append = false, store = null } = options;
  if (silent || showError === false) return;

  // 首屏失败：由 NetworkErrorState / FeedFetchErrorState 展示，不弹 Toast
  if (!append && store && !store.rawRows?.length && store.listFetchError) {
    return;
  }

  // 已有列表时 refresh 失败：保留旧数据，不弹 Toast
  if (!append && store?.rawRows?.length) {
    return;
  }

  // PC append 失败：FeedListTail 手动重试，不 Toast（H5 无重试入口，仍 Toast）
  if (append && store && paginatedFeedGetPlatform(store) === 'pc') {
    return;
  }

  const { t } = i18n.global;
  message.error(resolveRequestErrorMessage(err, t));
}

export async function runPaginatedFeedFetchPage(store, append, options = {}) {
  try {
    await paginatedFeedFetchPage(store, append, options);
    // FairOdds：列表已展示后再后台 batchPrice，不 await、不挡 loading
    if (options.skipFairOddsRefresh !== true) {
      scheduleFeedFairOddsRefresh(store);
    }
  } catch (err) {
    notifyFeedFetchError(err, { ...options, append, store });
  }
}

export async function runPaginatedFeedLoadMore(store, options = {}) {
  try {
    if (options.manual) {
      try {
        const { trackAnalyticsLog } = await import('@/utils/analytics-track');
        trackAnalyticsLog({
          key: 'feed.load_more',
          label: 'Feed加载更多',
          value: { source: store?.$id || undefined },
        });
      } catch {
        /* ignore */
      }
    }
    await paginatedFeedLoadMore(store, options);
    if (options.skipFairOddsRefresh !== true) {
      scheduleFeedFairOddsRefresh(store);
    }
  } catch (err) {
    notifyFeedFetchError(err, { ...options, append: true, store });
  }
}
